export const visibilityField = {
  program: {
    "vsbBlogs": 1,
    "vsbEvents": 1,
    "vsbOfficer": 2,
    "vsbResources": 1,
    "vsbThumbnail": 1,
    "vsbMainImage": 1,
    "vsbTbJourney": 2,
    "vsbTbCo-owner": 2,
    "vsbTypeIssues": 2,
    "vsbTanggalMulai": 2,
    "vsbTypeApproach": 2,
    "vsbTypeAudience": 2,
    "vsbJudulActivity": 1,
    "vsbStoryOfChange": 2,
    "vsbTanggalSelesai": 2,
    "vsbTbSubActivity": 2,
    "vsbDeskripsiPendek": 1,
    "vsbDeskripsiPanjang": 1,
    "vsbTbActivityResult": 2,
    "vsbTbPrecedingActivity": 2,
    "vsbTbPartnerActivityInternal": 3,
    "vsbTbPartnerActivityEksternal": 3
  },
  event: {
    "vsbTbPartnerActivityInternal": 1,
    "vsbTbPartnerActivityEksternal": 1,
    "vsbJudulActivity": 1,
    "vsbTanggalMulai": 1,
    "vsbTanggalSelesai": 1,
    "vsbThumbnail": 1,
    "vsbMainImage": 1,
    "vsbDeskripsiPendek": 1,
    "vsbDeskripsiPanjang": 1,
    "vsbTypeAudience": 1,
    "vsbTypeApproach": 1,
    "vsbTypeIssues": 1,
  },
  resource: {
    "vsbJudulArtikel": 1,
    "vsbThumbnail": 1,
    "vsbMainImage": 1,
    "vsbKategoriArtikel": 1,
    "vsbDeskripsiPendek": 1,
    "vsbDeskripsiPanjang": 1,
    "vsbTypeAudience": 1,
    "vsbTypeApproach": 1,
    "vsbTypeIssues": 1
  },
  blog: {
    "vsbJudulArtikel": 1,
    "vsbThumbnail": 1,
    "vsbMainImage": 1,
    "vsbKategoriArtikel": 1,
    "vsbDeskripsiPendek": 1,
    "vsbDeskripsiPanjang": 1,
    "vsbTypeAudience": 1,
    "vsbTypeApproach": 1,
    "vsbTypeIssues": 1
  },
  organization: {
    "vsbNamaOrganisasi": 1,
    "vsbTypeOrganisasi": 1,
    "vsbTypeAudiance": 1,
    "vsbTypeApproach": 1,
    "vsbTypeIssues": 1,
    "vsbTahunBerdiri": 1,
    "vsbLogoOrganisasi": 1,
    "vsbTeamMember": 1,
    "vsbTotalMember": 1,
    "vsbInstitutionProfile": 1,
    "vsbPartnerOrganisasiInternal": 1,
    "vsbHighlight": 1,
    "vsbDeskripsi": 1,
    "vsbEmailOrganisasi": 1,
    "vsbTeleponOrganisasi": 1,
    "vsbMissionStatement": 1,
    "vsbWebsiteOrganisasi": 1,
    "vsbTbMilestoneOrganisasi": 1,
    "vsbTbSosialMedia": 1,
    "vsbTbOrganisasiPartnerEksternal": 1,
    "vsbTbOrganisasiCabangEksternal": 1,
    "vsbTbOrganisasiCabangInternal": 1
  }
}
